import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { omit } from 'lodash';
import authentication from './authentication';
import configuration from './configuration';
import trunk from './trunk';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    configuration: omit(state.configuration, ['productsFetched', 'configurationsFetched']),
  }),
});

export default new Vuex.Store({
  state: {},
  modules: {
    authentication,
    configuration,
    trunk,
  },
  plugins: [vuexLocal.plugin],
});
